export const colMap = {
  1: 'styleCol1Highlighted',
  2: 'styleCol2Highlighted',
  3: 'styleCol3Highlighted',
  4: 'styleCol4Highlighted',
  5: 'styleCol5Highlighted',
};
